import { atom } from 'recoil';

export interface DocumentUploadProgressState {
  uploading: boolean;
  uploaded: boolean;
  uploadProgress: number; // Range from 1-100
}

export interface DocumentUploadProgressMap {
  // Maps a Document attachment ID to the upload progress state
  [key: string]: DocumentUploadProgressState;
}

export const documentUploadProgressMap = atom<DocumentUploadProgressMap>({
  key: 'documentUploadProgressMap',
  default: {},
});
